<div
    class="d-flex w-100 h-100"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="d-flex w-100 h-100 pulse-bonus"
        variant="colored"
        [collapsable]="false"
        (collapsedChange)="_collapsed = $event"
    >
        <cmps-container-header
            [separator]="false"
            [headerColour]="_widget?.headerColour"
            [textColour]="_widget?.headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content class="h-100">
            <div *ngIf="!_data?.compensationBonus">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100 h-100"
                *ngIf="_data?.compensationBonus"
            >
                <div class="sc-widget-content-row h-100">
                    <div
                        class="sc-widget-grid-title h-100 d-flex flex-column justify-content-center align-items-center"
                    >
                        {{ _i18n._9308_ESTIMATED_PAYOUT | translate }}
                    </div>
                    <div
                        class="sc-widget-grid-value h-100 d-flex flex-column justify-content-center align-items-center font-weight-bold"
                    >
                        <!--TODO app wide currency config-->
                        {{
                            _data?.compensationBonus?.bonusAmount
                                | currency: 'USD' : 'symbol-narrow' : '1.0-2'
                        }}
                    </div>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
